import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";

const ComponentFrequentQuestions = (props) => {
    const [view, setView] = useState(false);

    const handleView = () => {
        setView(!view);
    };

    return (
        <div className="add-question-main">
            <div onClick={handleView} className="add-question ">
                <div >
                    <strong className={view ? "red" : " "}>
                        {props.questions}
                    </strong>
                    
                    {/* <i className={"icon-question text-lg-left "+(view ? "fa fa-minus red" : "fa fa-plus ")}>
                            {" "}
                    </i> */}
                    
                </div>
                {view ? <div>{props.children}</div> : ""}
            </div>
        </div>
    );
};
ComponentFrequentQuestions.propTypes = {
    children: PropTypes.node.isRequired,
    questions: PropTypes.string,
};

export default ComponentFrequentQuestions;
